export default values => {
    let errors = {};

    if (!values.ConservatoryId) {
        errors.ConservatoryId = "Please select a product.";
    }
    
    if (!values.ConservatoryTypeId) {
        errors.ConservatoryTypeId = "Please select a type.";
    }

    if (!values.ConservatoryRoofMaterialId) {
        errors.ConservatoryRoofMaterialId = "Please select a Roof Material.";
    }

    if (!values.ConservatoryColourId) {
        errors.ConservatoryColourId = "Please select a colour.";
    }

    return errors;
};



// WEBPACK FOOTER //
// ./src/containers/ConservatoryForm/validate.js